<template>
  <div id="home">
    <div id="date">
      <p>
        {{ date }}
      </p>
      <p>
        FR
      </p>
    </div>
    <div id="ui">
      <div id="logoWrap">
        <img :src="require('../assets/assets2D/logo.svg')">
      </div>
      <p>
        CREATIVE<br>
        DEVELOPER<br>
        FREELANCE
      </p>
    </div>
    <canvas id="scene3D"></canvas>
  </div>
</template>

<script>
import World from '../scripts3D/World.js'
import Loader from '../utils/Loader.js'

export default {
  name: 'Home',
  data(){
    return {
      date: 0
    }
  },
  mounted(){ 
    document.title = 'SI. /HOME'
    const loader = new Loader()
    loader.open()
    
    const local = this
    const world = new World() 
    world.updateCanvas()
    world.setupHome()

    // Date
    const moment = require('moment')
    moment.locale('fr')

    function updateDate(){
      local.date = 
      `
      ${normalize(moment().hours())}:
      ${normalize(moment().minutes())}:
      ${normalize(moment().seconds())}
      `
    }
    function normalize(number){
      return String(number).padStart(2, '0')
    }

    setInterval(() => {
      updateDate()
    }, 1000)
    updateDate()
    
    this.$nextTick(() => {
      world.updateSizes()
    })
  }
}
</script>

<style scoped>
#home
{
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: #f5f5f5;
}
#ui
{
  position: fixed;
  bottom: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
}
/* Logo */
#logoWrap img
{
  height: 100%;
  widows: 100%;
  object-fit: contain;
}
/* Date */
#date
{
  position: absolute;
  color: #1a1a1a;
}
#date p
{
  margin: 0vw;    
}

@media screen and (orientation: landscape) {
  #ui
  {
    padding: 3vh;
  }
  #logoWrap
  {
    height: 15vh;
  }
  #date
  {
    font-size: 2vh;
    margin: 2vw;
  }
  #ui p
  {
    font-size: 2.5vh;
    line-height: 3vh;
    margin: 3vh;
  }
}
@media screen and (orientation: portrait) {
  #ui
  {
    padding: 3vw;
  }
  #logoWrap
  {
    height: 20vw;
  }
  #date
  {
    font-size: 2vh;
    margin: 2.1vw;
  }
  #ui p
  {
    font-size: 2.5vw;
    line-height: 3vw;
    margin: 3vw;
  }
}
</style>